import React from 'react';
import settingsParams from '../../../settingsParams';
import {useSettings} from '@wix/tpa-settings/react';
import s from './Headline.scss';
import {HTMLTag} from '../HTMLTag/HTMLTag';
import {ContinueShopping, ContinueShoppingPosition} from '../ContinueShopping/ContinueShopping';
import {useControllerProps} from '../../ControllerContext';
import {Caret} from '../Icons/Caret';

export enum HeadlineDataHook {
  root = 'HeadlineDataHook.root',
}

const RenderContinueShopping = () => {
  return (
    <div className={s.continueShopping}>
      <ContinueShopping position={ContinueShoppingPosition.headline} />
      <Caret className={s.caret} />
    </div>
  );
};

const RenderTitle = ({title}: {title: string}) => {
  return (
    <HTMLTag type="h1" className={s.title} data-hook={HeadlineDataHook.root}>
      {title}
    </HTMLTag>
  );
};

export function Headline() {
  const {get: getSettings} = useSettings();
  const {shouldRenderEmptyState} = useControllerProps().cartStore;
  const {shouldRenderContinueShopping} = useControllerProps().navigationStore;
  const withContinueShopping = shouldRenderContinueShopping && !shouldRenderEmptyState;

  return (
    <div className={s.headline}>
      <RenderTitle title={getSettings(settingsParams.CART_TITLE) as string} />

      {withContinueShopping && <RenderContinueShopping />}
    </div>
  );
}
